<template>
  <section id="forgotPasswordSuccessPage">
    <div class="container-wrapper">
      <div class="inner-container d-flex flex-column justify-content-center align-items-center">
        <span class="icon"><img src="/assets/images/check-circle-success.png" alt=""></span>
        <div class="inner-container__title">{{ $t('password_reminder') }}</div>
        <div class="inner-container__text">{{ $t('password_reminder_sent_to_email') }}</div>
        <div class="countDown">{{$t('redirecting')}} {{ countDownTimeInSec }} s.</div>

        <router-link :to="routesConst.LOGIN">
          <ButtonComponent class="order-status-form-button">
            <template #btnContent>{{ $t('next') }}</template>
          </ButtonComponent>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import './forgotPasswordSuccessPage.scss';

import {useStore} from "vuex";
import {defineComponent} from "vue";

// @ts-ignore
import CustomerForgotPasswordComponent from "../../components/CustomerForgotPassword/CustomerForgotPasswordComponent";

// @ts-ignore
import ButtonComponent from "../../components/Button/ButtonComponent.vue";
import {routesConst} from "../../routes";

export default defineComponent({
  name: 'ForgotPasswordSuccessPage',
  components: {ButtonComponent},
  props: {},
  setup() {
    const store = useStore();
    return {
      store
    };
  },
  data() {
    return {
      routesConst: routesConst,
      countDownTimeInSec: 5,
    }
  },

  methods: {
    countDownTimer(): void {
      this.countDownTimeInSec--;

      const interval = setInterval(() => {
        this.countDownTimeInSec--;

        if (this.countDownTimeInSec < 0) {
          this.$router.push(routesConst.LOGIN);
          clearTimeout(interval);
        }
      }, 1000);
    },
  },
  beforeCreate(): void {

  },
  created(): void {
    setTimeout(() => {
      this.countDownTimer();
    }, 1000);

  },
})
</script>